import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import BackdropDialog from 'common/components/BackdropDialog';
import { t } from 'services/localization';

interface Props {
	onEdit: (value: string) => void;
	onCancel: () => void;
	open: boolean;
	label: string;
	value: string | undefined;
}
const ShopperCommentModal = (props: Props) => {
	const classes = useStyles();
	const { onEdit, onCancel, open, label, value } = props;
	const [editedValue, setEditedValue] = useState(value ?? '');

	const handleSaveComment = () => {
		onEdit(editedValue);
	};

	return (
		<BackdropDialog
			isOpen={open}
			onClose={onCancel}
			label={label}
			body={
				<TextField
					label={t('shopperInfo.staffComment', 'Staff comment')}
					multiline
					rows={3}
					maxRows={5}
					value={editedValue}
					variant={'outlined'}
					onChange={(e) => setEditedValue(e.target.value)}
					className={classes.textField}
					InputLabelProps={{ shrink: true }}
				/>
			}
			width="xs"
			confirm={{
				label: t('common:actions.save'),
				callback: handleSaveComment,
				closeAfterDone: true,
			}}
			cancel={{
				label: t('common:actions.cancel'),
				autoFocus: false,
			}}
		/>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		textField: {
			width: '100%',
		},
	}),
);

export default ShopperCommentModal;
